import { useParams } from "react-router-dom";
import { useGetFeaturedProductsForOnline } from "../api/api.get";
import { IProductOnline } from "../types/types";
import { capitalize } from "../utils/functions";

export function FeaturesItems({
  onClick,
}: {
  onClick: (item: IProductOnline) => void;
}) {
  const { id } = useParams();
  const { data: featuredProductsData } = useGetFeaturedProductsForOnline(id);

  return (
    <div className="my-4 flex flex-col gap-4" style={{ zIndex: 1 }}>
      <h4 className="font-bold text-lg">Featured Items</h4>
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          gap: 16,
        }}
      >
        {featuredProductsData &&
          featuredProductsData.map((product, idx) => (
            <div className="item" key={idx} onClick={() => onClick(product)}>
              <img src={product?.cover} alt="Food 1" />
              <div className="item-title">{capitalize(product.title)}</div>
            </div>
          ))}
      </div>
    </div>
  );
}
